import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";

import Pagination from "@areas/shared/components/paginations/Pagination";

import { ReactComponent as ArrowIcon } from "@content/img/shared/home/svg/arrow-icon.svg";
import defaultLogo from "@content/img/shared/education/png/default-logo.png";

import styles from "@areas/schoolboy/pages/search/blocks/styles/results.module.css";
import paginationStyles from "@areas/college/components/pagination/styles/pagination.module.css";

function Results({ load, results, onChangePage }) {
  const getCountSchools = () => {
    let data = results.totals.filter(
      (p) => p.Name === "companies" && p.IdType === 4
    );
    if (data.length > 0) {
      return data[0].Value;
    }
    return results.total;
  };

  return (
    <div className={styles.info}>
      {load ? (
        <div className="d-flex w-100 justify-content-center mt-4">
          <ClipLoader />
        </div>
      ) : (
        <>
          <div className={styles.totals}>
            <span>Найдено школ:</span>
            <span>{getCountSchools()}</span>
          </div>
          <div className={styles.results}>
            {results.data.map((item) => (
              <div key={item.Id} className={styles.result}>
                <div className={styles.card}>
                  <div className={styles.city}>{item.Address}</div>
                  <div className={styles.info}>
                    <div className={styles.about}>
                      <img src={defaultLogo} alt="Результат" />
                      <div className={styles.title}>
                        {item.Shortname ? item.Shortname : item.Fullname}
                      </div>
                    </div>
                    <Link
                      to={`/obrazovanie-v-bashkortostane/shkoly-rb/${item.Slug}`}
                      className={styles.toCompany}
                      target="_blank"
                    >
                      Перейти к школе
                      <ArrowIcon />
                    </Link>
                  </div>
                  <Link
                    to={`/obrazovanie-v-bashkortostane/shkoly-rb/${item.Slug}`}
                    className={styles.more}
                    target="_blank"
                  >
                    <div className={styles.all}>Посмотреть все</div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      <Pagination
        load={load}
        itemsPerPage={2}
        totalItems={results.total}
        onChangePage={onChangePage}
        customStyles={{
          prev: paginationStyles.prev,
          current: paginationStyles.current,
          next: paginationStyles.next,
        }}
      />
    </div>
  );
}

export default Results;
